import { Button, Tooltip, useToastController } from "@fluentui/react-components";
import { Info32Filled, Info32Regular } from "@fluentui/react-icons";
import { useGlobalStatus } from '../../services/GlobalStatusProvider';
import { useState }  from "react";
import TooltipWatcherWidget from '../TooltipWatcherWidget';
import { useNavigate } from "react-router-dom";
import { SyncLeave, SyncHolidays, SyncResourceAssignments, SyncTimesheetStatus, SyncUsers, SyncLocations } from '../../services/apiService';
import { TOASTER_ID } from "../../services/toastUtils";
import { showSuccessToast, showErrorToast } from "../../services/toastUtils";

export default function Sync() {
  const { startLoad, endLoad, useStyles } = useGlobalStatus();
  const styles = useStyles();
  const [infoActive, setInfoActive] = useState(false);
  const navigate = useNavigate();
  const { dispatchToast } = useToastController(TOASTER_ID);

  const handleInfoToggle = () => {
    document.body.classList.contains("show-tooltip") ? document.body.classList.remove('show-tooltip') : document.body.classList.add('show-tooltip');
    setInfoActive(!infoActive);
  }

  const handleSyncUsers = async () => {
    startLoad();
    try {
      await SyncUsers();
      showSuccessToast(dispatchToast, "Sync complete");
    } catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out");
    }
    endLoad();
  } 

  const handleSyncResourceAssignments = async () => {
    startLoad();
    try {
      await SyncResourceAssignments();
      showSuccessToast(dispatchToast, "Sync complete");
    } catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out");
    }
    endLoad();
  } 

  const handleSyncTimesheetStatus = async () => {
    startLoad();
    try {
      var result = await SyncTimesheetStatus();
      if (!result) {
        endLoad();
        throw new Error("Error syncing Timesheet Status");
      }
      showSuccessToast(dispatchToast, "Sync complete");
    } catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out");
    }
    endLoad();
  }
  
  const handleSyncLeave = async () => {
    startLoad();
    try {
      var result = await SyncLeave();
      if (!result) {
        endLoad();
        throw new Error("Error syncing Leave")
      }
      showSuccessToast(dispatchToast, "Sync complete")
    }
    catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out")
    }
    endLoad();
  }

  const handleSyncHolidays = async () => {
    startLoad();
    try {
      var result = await SyncHolidays();
      if (!result) {
        endLoad();
        throw new Error("Error syncing Holidays")
      }
      showSuccessToast(dispatchToast, "Sync complete")
    }
    catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out")
    }
    endLoad();
  }

   const handleSyncLocations = async () => {
    startLoad();
    try {
      var result = await SyncLocations();
      if (!result) {
        endLoad();
        throw new Error("Error syncing Holidays")
      }
      showSuccessToast(dispatchToast, "Sync complete")
    }
    catch (error) {
      showErrorToast(dispatchToast, "Sync failed or timed out")
    }
    endLoad();
  }

  return (
    <div className="timesheet-container">
      <div className="navigation-controls">
        <TooltipWatcherWidget text="Click to go to Admin Home" direction='above'>
          <Button className={styles.buttonPrimary} onClick={() => navigate("/")}>Home</Button>
        </TooltipWatcherWidget>
        <div className="nav-center-sync-title">
          <span className="month-label" id="month-label">
            Syncing to Projectworks
          </span>
        </div>
        <Tooltip 
            withArrow
            positioning="before"
            relationship="description"
            content={{children: "Click to toggle help", className: styles.tooltip}}>
          {infoActive ? (
            <Info32Filled className="tooltip-filled" onClick={handleInfoToggle} />
          ) : (
            <Info32Regular className="tooltip" onClick={handleInfoToggle} />
          )}
        </Tooltip>
      </div>
      <br></br>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem'}}>
        <TooltipWatcherWidget text="Brings/Updates users from PW" direction='below'>
          <Button className={styles.buttonPrimary} onClick={handleSyncUsers}>Sync Users</Button>
        </TooltipWatcherWidget>
        <TooltipWatcherWidget text="Brings projects and timecodes for users from PW" direction='above'>
          <Button className={styles.buttonPrimary} onClick={handleSyncResourceAssignments}>Sync Resource Assignments</Button>
        </TooltipWatcherWidget>
        <TooltipWatcherWidget text="Updates timesheets, use when rejecting or approving" direction='below'>
          <Button className={styles.buttonPrimary} onClick={handleSyncTimesheetStatus}>Sync Timesheet Status</Button>
        </TooltipWatcherWidget>
        <TooltipWatcherWidget text="Updates leave" direction='above'>
          <Button className={styles.buttonPrimary} onClick={handleSyncLeave}>Sync Leave</Button>
        </TooltipWatcherWidget>
        <TooltipWatcherWidget text="Updates public holidays" direction='above'>
          <Button className={styles.buttonPrimary} onClick={handleSyncHolidays}>Sync Public Holidays</Button>
        </TooltipWatcherWidget>
        <TooltipWatcherWidget text="Updates Locations" direction='above'>
          <Button className={styles.buttonPrimary} onClick={handleSyncLocations}>Sync Locations</Button>
        </TooltipWatcherWidget>
      </div>
    </div>
  );
}
